module.exports = __webpack_public_path__ + "img/532m4.e38fa03e.jpg";